import React, { Component } from 'react';
import { compose } from 'recompose';
import M from 'materialize-css';
import { Link } from 'react-router-dom';
import moment from 'moment';
import $ from 'jquery';

import Preloader from '../partials/Preloader';
import TheEnd from '../partials/TheEnd';

import { withFirebase } from '../config';
import { AuthUserContext, withAuthorization } from '../session';

const INITIAL_STATE = {
  loadingDrafts: true,
  loadingPublic: true,
  loadingTotalDrafts: true,
  loadingTotalPublic: true,
  publicPoems: [],
  draftPoems: [],
  totalDrafts: 0,
  totalPublic: 0,
  limitDrafts: 5,
  limitPublic: 5,
  isDeletingPoem: false,
  loadingMoreDrafts: false,
  loadingMorePublic: false,
  isCreating: false
};

class MyPoems extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }
  componentDidMount() {
    document.title = 'My poems' + ' - Poetryphile';

    M.Tabs.init(this.tabs);
    M.Modal.init(this.modal);

    this.props.firebase.auth.onAuthStateChanged(authUser => {
      if (authUser) {
        let loadingMore = false;
        this.onListenForPoems(loadingMore);
      }
    });
  }
  componentDidUpdate() {
    M.Tabs.init(this.tabs);
    M.Modal.init(this.modal);
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('#scroll').fadeIn();
      } else {
        $('#scroll').fadeOut();
      }
    });
    $('#scroll').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 600);
      return false;
    });
  }
  async onFetchPoemData(snapshot, type) {
    let poems = [];
    for (let i in snapshot.docs) {
      // Loop through poems in snapshot

      let poem = snapshot.docs[i].data(); // Get poem data

      let poet = await this.props.firebase.user(poem.poetId).get(); // Get poem poet

      await poems.push({
        ...poem,
        poet: poet.data(),
        uid: snapshot.docs[i].id
      }); // Add poem, poet to poems array
    }

    if (type == 'drafts') {
      await this.setState({
        draftPoems: poems
      });
    } else {
      await this.setState({
        publicPoems: poems
      });
    }
  }
  async onGetDrafts(loadingMore) {
    const parent = this;
    try {
      await parent.props.firebase
        .poems()
        .orderBy('createdAt', 'desc')
        .limit(parent.state.limitDrafts)
        .where('poet.uid', '==', parent.props.firebase.auth.currentUser.uid)
        .where('type', '==', 'draft')
        .get()
        .then(async snapshot => {
          let type = 'drafts';
          await parent.onFetchPoemData(snapshot, type);
        });
      await parent.props.firebase
        .user(parent.props.firebase.auth.currentUser.uid)
        .get()
        .then(function (querySnapshot) {
          switch (loadingMore) {
            case true:
              parent.setState({
                totalDrafts: querySnapshot.data().totalDrafts,
                loadingMoreDrafts: false
              });
            case false:
              parent.setState({
                totalDrafts: querySnapshot.data().totalDrafts,
                loadingTotalDrafts: false,
                loadingDrafts: false
              });
          }
        });
    } catch (err) {
      console.log(err);
      switch (loadingMore) {
        case true:
          this.setState({
            totalDrafts: 0,
            loadingMoreDrafts: false
          });
        case false:
          this.setState({
            totalDrafts: 0,
            loadingTotalDrafts: false,
            loadingDrafts: false
          });
      }
    }
  }
  async onGetPublic(loadingMore) {
    try {
      const parent = this;
      await this.props.firebase
        .poems()
        .orderBy('createdAt', 'desc')
        .limit(this.state.limitPublic)
        .where('poet.uid', '==', this.props.firebase.auth.currentUser.uid)
        .where('type', '==', 'public')
        .get()
        .then(snapshot => {
          let type = 'public';
          this.onFetchPoemData(snapshot, type);
        });
      await this.props.firebase
        .user(parent.props.firebase.auth.currentUser.uid)
        .get()
        .then(function (querySnapshot) {
          switch (loadingMore) {
            case true:
              parent.setState({
                totalPublic: querySnapshot.data().totalPublic,
                loadingMorePublic: false
              });
            case false:
              parent.setState({
                totalPublic: querySnapshot.data().totalPublic,
                loadingTotalPublic: false,
                loadingPublic: false
              });
          }
        });
    } catch (err) {
      const parent = this;
      console.log(err);
      switch (loadingMore) {
        case true:
          parent.setState({
            totalPublic: 0,
            loadingMorePublic: false
          });
        case false:
          parent.setState({
            totalPublic: 0,
            loadingTotalPublic: false,
            loadingPublic: false,
            publicPoems: null
          });
      }
    }
  }
  onListenForPoems = async loadingMore => {
    this.onGetDrafts(loadingMore);
    this.onGetPublic(loadingMore);
  };
  loadMoreDrafts = () => {
    this.setState(
      state => ({
        limitDrafts: state.limitDrafts + 5,
        loadingMoreDrafts: true
      }),
      this.addDrafts
    );
  };
  loadMorePublic = () => {
    this.setState(
      state => ({
        limitPublic: state.limitPublic + 5,
        loadingMorePublic: true
      }),
      this.addPublic
    );
  };

  addDrafts = () => {
    let loadingMore = true;
    this.onGetDrafts(loadingMore);
  };

  addPublic = () => {
    let loadingMore = true;
    this.onGetPublic(loadingMore);
  };
  onCreatePoem = async (event, authUser) => {
    this.setState({ isCreating: true });
    let currentUser = await this.props.firebase
      .user(this.props.firebase.auth.currentUser.uid)
      .get();
    this.props.firebase
      .poems()
      .add({
        poet: authUser,
        poetRef: this.props.firebase.db.collection('users').doc(authUser.uid),
        poetId: authUser.uid,
        type: 'draft',
        title: 'Untitled poem',
        text: '',
        format: 'format_align_left',
        ink: 0,
        views: 0,
        inkers: [],
        tags: [{ tag: 'Poetryphile' }],
        dailyInk: 0,
        weeklyInk: 0,
        monthlyInk: 0,
        createdAt: this.props.firebase.fieldValue.serverTimestamp(),
        isClassic: currentUser.data().isFamous ? true : false
      })
      .then(async poem => {
        let newPoem = await this.props.firebase.poem(poem.id).get();
        this.setState({
          isCreating: false
        });
        await this.props.firebase.db
          .collection('poems')
          .doc('collectionInfo')
          .update({
            totalDrafts: this.props.firebase.fieldValue.increment(1),
            total: this.props.firebase.fieldValue.increment(1)
          });
        await this.props.firebase.db
          .collection('users')
          .doc(newPoem.data().poetId)
          .update({
            totalDrafts: this.props.firebase.fieldValue.increment(1),
            totalPoems: this.props.firebase.fieldValue.increment(1)
          });
        if (currentUser.data().isFamous) {
          await this.props.firebase.db
            .collection('poems')
            .doc('collectionInfo')
            .update({
              classics: this.props.firebase.fieldValue.increment(1)
            });
        }
        M.toast({ html: 'Poem created' });
        this.props.history.push(`/poems/${poem.id}/edit`);
      })
      .catch(err => {
        this.setState({ isCreating: false });
        M.toast({ html: err.message });
      });
  };
  onRemovePoem = async uid => {
    try {
      const parent = this;
      this.setState({ isDeletingPoem: true });
      let poem = await this.props.firebase.poem(uid).get();
      await this.props.firebase
        .poem(uid)
        .delete()
        .then(async () => {
          if (poem.data().type == 'draft') {
            parent.setState({
              isDeletingPoem: false
            });
            await this.props.firebase.db
              .collection('poems')
              .doc('collectionInfo')
              .update({
                totalDrafts: this.props.firebase.fieldValue.increment(-1),
                total: this.props.firebase.fieldValue.increment(-1)
              });
            await this.props.firebase.db
              .collection('users')
              .doc(this.props.firebase.auth.currentUser.uid)
              .update({
                totalDrafts: this.props.firebase.fieldValue.increment(-1),
                totalPoems: this.props.firebase.fieldValue.increment(-1)
              });
          } else {
            parent.setState({
              isDeletingPoem: false
            });
            await this.props.firebase.db
              .collection('poems')
              .doc('collectionInfo')
              .update({
                totalPublic: this.props.firebase.fieldValue.increment(-1),
                total: this.props.firebase.fieldValue.increment(-1)
              });
            await this.props.firebase.db
              .collection('users')
              .doc(this.props.firebase.auth.currentUser.uid)
              .update({
                totalPublic: this.props.firebase.fieldValue.increment(-1),
                totalPoems: this.props.firebase.fieldValue.increment(-1)
              });
          }
          M.toast({ html: 'Poem Deleted' });
          let loadingMore = false;
          parent.onListenForPoems(loadingMore);
        });
    } catch (err) {
      console.log(err);
      this.setState({ isDeletingPoem: false });
      M.toast({ html: 'Unable to delete poem' });
    }
  };
  render() {
    const {
      loadingDrafts,
      loadingPublic,
      loadingTotalDrafts,
      loadingTotalPublic,
      totalDrafts,
      totalPublic,
      publicPoems,
      draftPoems,
      isDeletingPoem,
      limitDrafts,
      limitPublic,
      loadingMoreDrafts,
      loadingMorePublic,
      isCreating
    } = this.state;
    return (
      <div>
        {loadingDrafts ||
        loadingPublic ||
        loadingTotalDrafts ||
        loadingTotalPublic ? (
          <Preloader />
        ) : (
          <div>
            <AuthUserContext.Consumer>
              {authUser => (
                <div>
                  <div
                    ref={modal => {
                      this.modal = modal;
                    }}
                    id='modal-delete-poem'
                    className='modal'>
                    <div className='modal-content'>
                      <h4 id='delete-poem-header'>
                        Delete poem
                        <a
                          id='modal-close'
                          className='modal-close btn btn-floating waves-effect btn-flat close'>
                          <i className='small material-icons'>close</i>
                        </a>
                      </h4>
                      <p style={{ fontSize: '17px' }}>
                        Do you really wish to delete this poem?
                      </p>
                      {isDeletingPoem && (
                        <button
                          disabled={true}
                          id='delete-poem-btn-confirm'
                          className='btn z-depth-0 waves-effect'>
                          Deleteing...
                        </button>
                      )}
                      {isDeletingPoem == false && (
                        <button
                          onClick={() => this.onRemovePoem(window.poemToDelete)}
                          id='delete-poem-btn-confirm'
                          className='btn z-depth-0 waves-effect modal-close'>
                          Delete
                        </button>
                      )}
                      &nbsp;&nbsp;&nbsp;
                      <a
                        style={{ marginLeft: '-20px' }}
                        className='modal-close btn z-depth-0'
                        id='delete-poem-btn-cancel'>
                        Cancel
                      </a>
                    </div>
                  </div>
                  <div className='fixed-action-btn horizontal hide-on-med-and-up'>
                    <a
                      disabled={isCreating}
                      onClick={event => this.onCreatePoem(event, authUser)}
                      id='create-poem'
                      className='btn-floating btn-large modal-trigger'
                      data-target='modal-create-poem'>
                      <i className='large material-icons'>add</i>
                    </a>
                  </div>
                  <div
                    id='scroll'
                    style={{ top: '25px' }}
                    className='fixed-action-btn horizontal'>
                    <a
                      style={{ backgroundColor: '#da694b' }}
                      className='btn-floating btn-small'>
                      <i className='large material-icons'>arrow_drop_up</i>
                    </a>
                  </div>
                  <ul
                    id='poems'
                    style={{ marginTop: '50px' }}
                    className='collection with-header container'>
                    <li className='collection-header'>
                      <p id='my-poems' className='futura'>
                        My Poems
                      </p>
                      <a
                        disabled={isCreating}
                        onClick={event => this.onCreatePoem(event, authUser)}
                        id='write-poem-btn'
                        className='btn z-depth-0 right hide-on-small-only'>
                        <i
                          id='create-icon'
                          style={{ color: '#da694b' }}
                          className='material-icons left'>
                          add
                        </i>
                        Write poem
                      </a>
                      <br />
                      <ul
                        ref={tabs => {
                          this.tabs = tabs;
                        }}
                        className='tabs tabs-fixed-width left'>
                        <li className='tab'>
                          <a id='drafts-tab' className='active' href='#drafts'>
                            Drafts&nbsp;
                            <span>{'(' + totalDrafts + ')'}</span>
                          </a>
                        </li>
                        <li className='tab'>
                          <a id='public-tab' href='#public'>
                            Public&nbsp;<span>{'(' + totalPublic + ')'}</span>
                          </a>
                        </li>
                      </ul>
                      <br />
                      <br />
                    </li>
                    <div id='drafts'>
                      {totalDrafts < 1 ? (
                        <li id='no-drafts' className='collection-item'>
                          <center>
                            <svg
                              style={{ width: '200px', marginTop: '-5px' }}
                              id='Layer_1'
                              data-name='Layer 1'
                              xmlns='http://www.w3.org/2000/svg'
                              viewBox='0 0 2000 2000'>
                              <title>Poetryphile No Poems</title>
                              <path
                                d='M1593.53,554.29h95.88a59.42,59.42,0,0,0,59.43-59.42h0a59.42,59.42,0,0,0-59.43-59.42h-95.88Z'
                                style={{ fill: '#da694b' }}
                              />
                              <path
                                d='M1367.81,1564.56h81.42a59.43,59.43,0,0,0,59.43-59.43h0a59.43,59.43,0,0,0-59.43-59.43h-81.42Z'
                                style={{ fill: '#da694b' }}
                              />
                              <path
                                d='M637.4,554.29v97.8a237.09,237.09,0,0,0,178.27,80.49h534.85V673.14H815.67a178.33,178.33,0,0,1-168.1-118.85Z'
                                style={{ fill: '#fff' }}
                              />
                              <path
                                d='M1640.15,435.43C1613.77,332.9,1520.7,257.16,1410,257.16H815.67c-1.91,0-3.81,0-5.71.07l-1.8.06c-1.3,0-2.6.09-3.89.15l-2.12.11c-1.2.07-2.39.14-3.58.23l-2.17.16c-1.2.09-2.41.2-3.6.32l-2,.19c-1.39.15-2.78.31-4.16.48l-1.4.17c-1.82.23-3.62.48-5.43.75l-1.77.29c-1.23.2-2.45.39-3.67.61l-2.24.41-3.18.61-2.36.48-3.06.67-2.35.53-3.13.77c-.73.18-1.46.35-2.19.54-1.5.39-3,.8-4.49,1.22l-2.55.74c-1,.3-2.1.61-3.13.93-.84.25-1.66.52-2.49.79l-2.64.85-2.58.88-2.49.88-2.61.95-2.39.91-2.64,1-2.26.92q-2.65,1.09-5.28,2.25l-1.85.8-2.81,1.3c-.67.31-1.33.61-2,.93-.94.44-1.87.9-2.8,1.35l-1.92,1c-.94.47-1.87.95-2.8,1.43l-1.82,1c-.95.51-1.91,1-2.85,1.54-.51.27-1,.56-1.52.84q-5.26,2.94-10.35,6.14l-1.13.7q-1.49.94-3,1.92l-1.38.91-2.88,1.95-1.36.95c-1,.67-1.94,1.36-2.91,2.05l-1.1.8q-7.07,5.14-13.72,10.79l-.88.74q-1.44,1.23-2.85,2.49l-1,.87-2.81,2.55-.85.79c-1,.91-2,1.83-2.92,2.76l-.16.15q-5,4.82-9.69,9.92l-.33.35c-.93,1-1.84,2-2.74,3-.23.26-.46.51-.68.77-.88,1-1.75,2-2.61,3l-.66.78c-.88,1-1.76,2.1-2.63,3.16l-.29.37q-5.82,7.15-11.07,14.77l-.39.56c-.79,1.14-1.56,2.3-2.33,3.46l-.48.73c-.77,1.18-1.53,2.36-2.28,3.55-.11.16-.21.32-.31.48q-5,8-9.38,16.35l-.07.15c-.69,1.31-1.36,2.63-2,4-.09.2-.19.4-.29.6-.65,1.3-1.28,2.61-1.9,3.93l-.23.5a233.79,233.79,0,0,0-9,22.14c0,.1-.07.19-.1.28-.51,1.45-1,2.92-1.48,4.38l-.12.39q-3.37,10.38-5.8,21.15a.94.94,0,0,0,0,.16c-.49,2.18-.94,4.38-1.37,6.58-.08.38-.15.77-.22,1.15q-.57,3-1.06,6c-.06.34-.12.68-.17,1q-1.11,7-1.8,14.14c-.05.46-.08.93-.13,1.39q-.26,2.82-.45,5.66c0,.61-.07,1.21-.11,1.82-.11,1.88-.2,3.78-.27,5.67l-.06,1.46q-.11,3.6-.11,7.23v772.55c-110.74,0-203.82,75.78-230.21,178.29a239.75,239.75,0,0,0,0,118.84c26.39,102.53,119.47,178.29,230.21,178.29h594.29c110.74,0,203.82-75.76,230.21-178.29a238.06,238.06,0,0,0,7.49-59.42V732.58c110.75,0,203.83-75.78,230.22-178.29a239.21,239.21,0,0,0,0-118.86ZM817.54,673.14h-1.87a177.36,177.36,0,1,1,1.87,0Zm-417.85,832c0-98.44,79.83-178.27,178.27-178.27v356.56C479.52,1683.42,399.69,1603.59,399.69,1505.13Zm950.83,0c0,98.46-79.83,178.29-178.27,178.29H637.4V652.11a239,239,0,0,0,62.18,50.23l.06,0c1.76,1,3.53,2,5.32,2.89l.2.11c1.76.92,3.54,1.83,5.32,2.71l.23.11q2.71,1.34,5.47,2.61l.1.05a236.25,236.25,0,0,0,35.3,13l.28.07q2.82.8,5.66,1.5l.93.23c1.69.42,3.38.82,5.09,1.2l.45.11.83.17c1.59.35,3.19.68,4.8,1l1.5.28c1.54.3,3.09.57,4.65.84l1.62.27c1.54.25,3.08.48,4.62.7l1.66.23c1.56.21,3.12.4,4.69.58l1.6.18c1.63.18,3.27.33,4.9.47l1.42.13c1.78.14,3.57.26,5.36.37l1,.06c4.31.23,8.66.36,13,.36h534.85Zm59.43-832h-437a237.67,237.67,0,0,0,0-356.56H1410a178.3,178.3,0,0,1,178.29,178.29C1588.24,593.31,1508.41,673.14,1410,673.14Z'
                                style={{ fill: '#413043' }}
                              />
                              <rect
                                x='671.4'
                                y='435.44'
                                width='178.28'
                                height='118.86'
                                rx='59.43'
                                ry='59.43'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='292.02'
                                y='1445.7'
                                width='218.24'
                                height='118.86'
                                rx='59.43'
                                ry='59.43'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='850.25'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 1760.04) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='969.32'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 1998.18) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1088.39'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 2236.32) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1207.46'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 2474.45) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1326.53'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 2712.59) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1445.6'
                                width='357.21'
                                height='59.53'
                                transform='translate(1868.86 2950.73) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                            </svg>
                            <h4 id='no-draft-poems' className='futura'>
                              You do not have any poem drafts!
                            </h4>
                          </center>
                        </li>
                      ) : (
                        <DraftList
                          poems={draftPoems}
                          limitDrafts={limitDrafts}
                          totalDrafts={totalDrafts}
                          loadingMoreDrafts={loadingMoreDrafts}
                          loadMoreDrafts={this.loadMoreDrafts}
                        />
                      )}
                    </div>
                    <div id='public'>
                      {totalPublic < 1 ? (
                        <li id='no-public' className='collection-item'>
                          <center>
                            <svg
                              style={{ width: '200px', marginTop: '-5px' }}
                              id='Layer_1'
                              data-name='Layer 1'
                              xmlns='http://www.w3.org/2000/svg'
                              viewBox='0 0 2000 2000'>
                              <title>Poetryphile No Poems</title>
                              <path
                                d='M1593.53,554.29h95.88a59.42,59.42,0,0,0,59.43-59.42h0a59.42,59.42,0,0,0-59.43-59.42h-95.88Z'
                                style={{ fill: '#da694b' }}
                              />
                              <path
                                d='M1367.81,1564.56h81.42a59.43,59.43,0,0,0,59.43-59.43h0a59.43,59.43,0,0,0-59.43-59.43h-81.42Z'
                                style={{ fill: '#da694b' }}
                              />
                              <path
                                d='M637.4,554.29v97.8a237.09,237.09,0,0,0,178.27,80.49h534.85V673.14H815.67a178.33,178.33,0,0,1-168.1-118.85Z'
                                style={{ fill: '#fff' }}
                              />
                              <path
                                d='M1640.15,435.43C1613.77,332.9,1520.7,257.16,1410,257.16H815.67c-1.91,0-3.81,0-5.71.07l-1.8.06c-1.3,0-2.6.09-3.89.15l-2.12.11c-1.2.07-2.39.14-3.58.23l-2.17.16c-1.2.09-2.41.2-3.6.32l-2,.19c-1.39.15-2.78.31-4.16.48l-1.4.17c-1.82.23-3.62.48-5.43.75l-1.77.29c-1.23.2-2.45.39-3.67.61l-2.24.41-3.18.61-2.36.48-3.06.67-2.35.53-3.13.77c-.73.18-1.46.35-2.19.54-1.5.39-3,.8-4.49,1.22l-2.55.74c-1,.3-2.1.61-3.13.93-.84.25-1.66.52-2.49.79l-2.64.85-2.58.88-2.49.88-2.61.95-2.39.91-2.64,1-2.26.92q-2.65,1.09-5.28,2.25l-1.85.8-2.81,1.3c-.67.31-1.33.61-2,.93-.94.44-1.87.9-2.8,1.35l-1.92,1c-.94.47-1.87.95-2.8,1.43l-1.82,1c-.95.51-1.91,1-2.85,1.54-.51.27-1,.56-1.52.84q-5.26,2.94-10.35,6.14l-1.13.7q-1.49.94-3,1.92l-1.38.91-2.88,1.95-1.36.95c-1,.67-1.94,1.36-2.91,2.05l-1.1.8q-7.07,5.14-13.72,10.79l-.88.74q-1.44,1.23-2.85,2.49l-1,.87-2.81,2.55-.85.79c-1,.91-2,1.83-2.92,2.76l-.16.15q-5,4.82-9.69,9.92l-.33.35c-.93,1-1.84,2-2.74,3-.23.26-.46.51-.68.77-.88,1-1.75,2-2.61,3l-.66.78c-.88,1-1.76,2.1-2.63,3.16l-.29.37q-5.82,7.15-11.07,14.77l-.39.56c-.79,1.14-1.56,2.3-2.33,3.46l-.48.73c-.77,1.18-1.53,2.36-2.28,3.55-.11.16-.21.32-.31.48q-5,8-9.38,16.35l-.07.15c-.69,1.31-1.36,2.63-2,4-.09.2-.19.4-.29.6-.65,1.3-1.28,2.61-1.9,3.93l-.23.5a233.79,233.79,0,0,0-9,22.14c0,.1-.07.19-.1.28-.51,1.45-1,2.92-1.48,4.38l-.12.39q-3.37,10.38-5.8,21.15a.94.94,0,0,0,0,.16c-.49,2.18-.94,4.38-1.37,6.58-.08.38-.15.77-.22,1.15q-.57,3-1.06,6c-.06.34-.12.68-.17,1q-1.11,7-1.8,14.14c-.05.46-.08.93-.13,1.39q-.26,2.82-.45,5.66c0,.61-.07,1.21-.11,1.82-.11,1.88-.2,3.78-.27,5.67l-.06,1.46q-.11,3.6-.11,7.23v772.55c-110.74,0-203.82,75.78-230.21,178.29a239.75,239.75,0,0,0,0,118.84c26.39,102.53,119.47,178.29,230.21,178.29h594.29c110.74,0,203.82-75.76,230.21-178.29a238.06,238.06,0,0,0,7.49-59.42V732.58c110.75,0,203.83-75.78,230.22-178.29a239.21,239.21,0,0,0,0-118.86ZM817.54,673.14h-1.87a177.36,177.36,0,1,1,1.87,0Zm-417.85,832c0-98.44,79.83-178.27,178.27-178.27v356.56C479.52,1683.42,399.69,1603.59,399.69,1505.13Zm950.83,0c0,98.46-79.83,178.29-178.27,178.29H637.4V652.11a239,239,0,0,0,62.18,50.23l.06,0c1.76,1,3.53,2,5.32,2.89l.2.11c1.76.92,3.54,1.83,5.32,2.71l.23.11q2.71,1.34,5.47,2.61l.1.05a236.25,236.25,0,0,0,35.3,13l.28.07q2.82.8,5.66,1.5l.93.23c1.69.42,3.38.82,5.09,1.2l.45.11.83.17c1.59.35,3.19.68,4.8,1l1.5.28c1.54.3,3.09.57,4.65.84l1.62.27c1.54.25,3.08.48,4.62.7l1.66.23c1.56.21,3.12.4,4.69.58l1.6.18c1.63.18,3.27.33,4.9.47l1.42.13c1.78.14,3.57.26,5.36.37l1,.06c4.31.23,8.66.36,13,.36h534.85Zm59.43-832h-437a237.67,237.67,0,0,0,0-356.56H1410a178.3,178.3,0,0,1,178.29,178.29C1588.24,593.31,1508.41,673.14,1410,673.14Z'
                                style={{ fill: '#413043' }}
                              />
                              <rect
                                x='671.4'
                                y='435.44'
                                width='178.28'
                                height='118.86'
                                rx='59.43'
                                ry='59.43'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='292.02'
                                y='1445.7'
                                width='218.24'
                                height='118.86'
                                rx='59.43'
                                ry='59.43'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='850.25'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 1760.04) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='969.32'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 1998.18) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1088.39'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 2236.32) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1207.46'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 2474.45) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1326.53'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 2712.59) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1445.6'
                                width='357.21'
                                height='59.53'
                                transform='translate(1868.86 2950.73) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                            </svg>
                            <h4 id='no-public-poems' className='futura'>
                              You do not have any public poems!
                            </h4>
                          </center>
                        </li>
                      ) : (
                        <PublicList
                          poems={publicPoems}
                          limitPublic={limitPublic}
                          totalPublic={totalPublic}
                          loadingMorePublic={loadingMorePublic}
                          loadMorePublic={this.loadMorePublic}
                        />
                      )}
                    </div>
                  </ul>
                  <br />
                </div>
              )}
            </AuthUserContext.Consumer>
          </div>
        )}
      </div>
    );
  }
}

const DraftList = ({
  poems,
  limitDrafts,
  totalDrafts,
  loadingMoreDrafts,
  loadMoreDrafts
}) => (
  <ul>
    {poems &&
      poems.map(poem => (
        <li key={poem.uid} className='collection-item'>
          {poem.title.replace(/\s/g, '') == '' && (
            <a
              style={{ paddingTop: '15px' }}
              href={`/poems/${poem.uid}/edit`}
              className='poem-title-new futura'>
              Untitled Poem
            </a>
          )}
          <a
            style={{
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              paddingTop: '15px'
            }}
            href={`/poems/${poem.uid}/edit`}
            className='poem-title-new futura'>
            {poem.title}
          </a>
          <br />
          {poem.classicDate == undefined ? (
            <div>
              {poem.createdAt != undefined ? (
                <p className='created-at'>
                  {moment(poem.createdAt.toDate()).fromNow()}
                </p>
              ) : (
                <p className='created-at'>a few seconds ago</p>
              )}
            </div>
          ) : (
            <div>
              <p className='created-at'>{poem.classicDate}</p>
            </div>
          )}
          <div
            className='poem-text'
            id={poem.uid}
            style={{
              marginTop: '5px',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              marginBottom: '10px'
            }}>
            {poem.text.substring(0, 150)}
          </div>
          <a
            href={'/poems/' + poem.uid + '/edit'}
            id='edit-poem-btn'
            className='btn z-depth-0 waves-effect'>
            Edit
          </a>
          <a
            href='#!'
            style={{ marginLeft: '-5px' }}
            onClick={() => (window.poemToDelete = poem.uid)}
            id='delete-poem-btn'
            className='modal-trigger btn z-depth-0'
            data-target='modal-delete-poem'>
            Delete
          </a>
          <p style={{ visibility: 'hidden', marginBottom: '25px' }}></p>
        </li>
      ))}
    {limitDrafts >= totalDrafts && loadingMoreDrafts == false && <TheEnd />}
    {poems && totalDrafts > limitDrafts && loadingMoreDrafts == false && (
      <li className='collection-item'>
        <center>
          <a href='#!' className='load-more' onClick={loadMoreDrafts}>
            Load More
          </a>
        </center>
      </li>
    )}
    {poems && totalDrafts + 5 > limitDrafts && loadingMoreDrafts == true && (
      <li className='collection-item'>
        <center>
          <a href='#!' className='loading-more'>
            Loading more...
          </a>
        </center>
      </li>
    )}
  </ul>
);

const PublicList = ({
  poems,
  limitPublic,
  totalPublic,
  loadingMorePublic,
  loadMorePublic
}) => (
  <div>
    {poems &&
      poems.map(poem => (
        <li key={poem.uid} className='collection-item'>
          {poem.title.replace(/\s/g, '') == '' && (
            <a
              style={{ paddingTop: '15px' }}
              href={`/poems/${poem.uid}/edit`}
              className='poem-title-new futura'>
              Untitled Poem
            </a>
          )}
          <a
            style={{
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              paddingTop: '15px'
            }}
            href={`/poems/${poem.uid}/edit`}
            className='poem-title-new futura'>
            {poem.title}
          </a>
          <br />
          {poem.classicDate == undefined ? (
            <div>
              {poem.datePublic != undefined ? (
                <p className='created-at'>
                  {moment(poem.datePublic.toDate()).fromNow()}
                </p>
              ) : (
                <p className='created-at'>a few seconds ago</p>
              )}
            </div>
          ) : (
            <div>
              <p className='created-at'>{poem.classicDate}</p>
            </div>
          )}
          <div
            className='poem-text'
            id={poem.uid}
            style={{
              marginTop: '5px',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              marginBottom: '10px'
            }}>
            {poem.text.substring(0, 150)}
          </div>
          <a
            href={'/poems/' + poem.uid + '/edit'}
            id='edit-poem-btn'
            className='btn z-depth-0 waves-effect'>
            Edit
          </a>
          <a
            style={{ marginLeft: '-5px' }}
            onClick={() => (window.poemToDelete = poem.uid)}
            id='delete-poem-btn'
            className='modal-trigger btn z-depth-0'
            data-target='modal-delete-poem'>
            Delete
          </a>
          <p style={{ visibility: 'hidden', marginBottom: '25px' }}></p>
        </li>
      ))}
    {limitPublic >= totalPublic && loadingMorePublic == false && <TheEnd />}
    {poems && totalPublic > limitPublic && loadingMorePublic == false && (
      <li className='collection-item'>
        <center>
          <a href='#!' className='load-more' onClick={loadMorePublic}>
            Load More
          </a>
        </center>
      </li>
    )}
    {poems && totalPublic + 5 > limitPublic && loadingMorePublic == true && (
      <li className='collection-item'>
        <center>
          <a hef='#!' className='loading-more'>
            Loading more...
          </a>
        </center>
      </li>
    )}
  </div>
);
const condition = authUser => !!authUser;

export default compose(withAuthorization(condition), withFirebase)(MyPoems);
